<script lang="ts" setup>
defineProps<{
    width?: number;
    height?: number;
}>();

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :style="[width ? { width: width + 'px' } : undefined, height ? { height: height + 'px' } : undefined]"
       viewBox="0 0 100 100"
       preserveAspectRatio="none"
  >
    <rect x="0"
          y="0"
          width="100"
          height="100"
          fill="url(#gradient)"
    />
    <defs>
      <linearGradient id="gradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="0%"
                      spreadMethod="reflect">
        <stop offset="0%"
              stop-color="var(--layer-floor-1)" />
        <stop offset="50%"
              stop-color="var(--layer-floor-0)" />
        <stop offset="100%"
              stop-color="var(--layer-floor-1)" />

        <animateTransform attributeName="gradientTransform"
                          type="translate"
                          from="-0.5"
                          to="0.5"
                          dur="2.5s"
                          repeatCount="indefinite"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
